
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function CAbserviceinsindhudurg() {



const cardData = {
  keyword: 'Cab Service in Sindhudurg MIDC',
  heading: 'Trusted Corporate Cab Services in Sindhudurg MIDC by eTravo',
  headingDescription: 'eTravo offers comprehensive corporate cab services in Sindhudurg MIDC designed to meet the dynamic transportation needs of businesses and industries in the region. Our service prioritizes safety, punctuality, and comfort, helping companies ensure smooth daily commutes for their employees. From employee transport and executive rides to business meeting cabs and shuttle services, we provide reliable and affordable solutions tailored to the local industrial environment. Equipped with modern vehicles and professional drivers, eTravo is your trusted partner for efficient corporate transportation in Sindhudurg MIDC.',

  top: 'Key Industrial Zones and Locations Covered in Sindhudurg MIDC',
  topPlaces: [
    {
      title: 'Sindhudurg Industrial Estate',
      description: 'Serving multiple manufacturing and processing units with dedicated employee transport and corporate shuttle services, ensuring timely commutes.'
    },
    {
      title: 'Food Processing and Agro-Industry Areas',
      description: 'Specialized cab solutions catering to the unique timing and hygiene standards required by food and agro-processing industries.'
    },
    {
      title: 'Logistics and Warehousing Zones',
      description: 'Reliable and flexible cab services designed to support logistics staff shifts and operational needs around the clock.'
    },
    {
      title: 'Nearby Residential Hubs',
      description: 'Connecting residential areas such as Kankavli and Malvan with the industrial belt for efficient and safe employee transportation.'
    },
    {
      title: 'Corporate Offices and Business Parks',
      description: 'Providing seamless business cab rentals and executive travel services to support professional meetings and corporate events.'
    }
  ],

  services: [
    {
      name: 'Sindhudurg MIDC Corporate Cab Rentals',
      description: 'Flexible and customizable corporate cab rental plans that accommodate daily, weekly, and monthly transportation needs of businesses operating in Sindhudurg MIDC.'
    },
    {
      name: 'Employee Transport Cab Sindhudurg MIDC',
      description: 'Safe and punctual employee transport services designed to manage large teams with multiple shift schedules effectively.'
    },
    {
      name: 'Business Cab Services Sindhudurg MIDC',
      description: 'Professional cab services aimed at facilitating business meetings, client visits, and executive travel with premium vehicles.'
    },
    {
      name: 'Corporate Staff Cabs Sindhudurg MIDC',
      description: 'Dedicated staff cabs that ensure comfortable and secure travel for employees while maintaining hygiene and safety protocols.'
    },
    {
      name: 'Reliable Corporate Cab Service Sindhudurg MIDC',
      description: 'Our fleet is maintained to the highest standards and operated by trained drivers committed to providing a reliable service every time.'
    },
    {
      name: 'AC Corporate Cabs Sindhudurg MIDC',
      description: 'Fully air-conditioned vehicles to offer a comfortable and refreshing commute regardless of weather conditions.'
    },
    {
      name: 'Staff Pickup and Drop Cab Sindhudurg MIDC',
      description: 'Efficiently planned pickup and drop routes designed to minimize wait times and optimize route efficiency for employee convenience.'
    },
    {
      name: 'Affordable Business Cab Rentals Sindhudurg MIDC',
      description: 'Cost-effective cab rental options suitable for small, medium, and large enterprises looking for quality corporate transportation.'
    },
    {
      name: 'Executive Cab Services Sindhudurg MIDC',
      description: 'Luxurious and professional services for senior executives and VIPs, offering a premium travel experience with dedicated chauffeurs.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Sindhudurg MIDC',
      description: 'Convenient monthly rental packages ensuring dedicated vehicle availability and streamlined transportation management.'
    },
    {
      name: 'Industrial Area Employee Transport Sindhudurg MIDC',
      description: 'Tailored transport services addressing the specific demands of industrial employees working in varied shifts.'
    },
    {
      name: 'Corporate Client Cabs Sindhudurg MIDC',
      description: 'Client transport services that create a positive impression with comfortable, timely, and professional rides.'
    },
    {
      name: 'Business Meeting Cabs Sindhudurg MIDC',
      description: 'Reliable cab services arranged on-demand for business meetings, client visits, and corporate events within the industrial zone.'
    },
    {
      name: 'Sindhudurg Industrial Area Cab Hire',
      description: 'Short and long-term cab hire services to support project teams, industrial events, and special corporate transportation needs.'
    },
    {
      name: 'Corporate Shuttle Cabs Sindhudurg MIDC',
      description: 'Regular shuttle services connecting key residential areas with Sindhudurg MIDC to ensure smooth daily employee commutes.'
    }
  ],

  tableData: [
    ['Sindhudurg MIDC Corporate Cab Rentals', 'Employee Transport Cab Sindhudurg MIDC'],
    ['Business Cab Services Sindhudurg MIDC', 'Corporate Staff Cabs Sindhudurg MIDC'],
    ['Reliable Corporate Cab Service Sindhudurg MIDC', 'AC Corporate Cabs Sindhudurg MIDC'],
    ['Staff Pickup and Drop Cab Sindhudurg MIDC', 'Affordable Business Cab Rentals Sindhudurg MIDC'],
    ['Executive Cab Services Sindhudurg MIDC', 'Monthly Corporate Cab Rentals Sindhudurg MIDC'],
    ['Industrial Area Employee Transport Sindhudurg MIDC', 'Corporate Client Cabs Sindhudurg MIDC'],
    ['Business Meeting Cabs Sindhudurg MIDC', 'Sindhudurg Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Sindhudurg MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Services for Sindhudurg MIDC",
    "WhyChoosedescription": "eTravo delivers dependable and tailored corporate cab solutions to industries operating in Sindhudurg MIDC—an emerging industrial zone known for its agro-processing, food exports, and eco-industrial development. Our services are designed to ensure consistent and timely transportation for employees and executives working in remote or semi-urban areas. With a focus on punctuality, safety, and service flexibility, we help businesses improve operational efficiency while offering a comfortable commute experience."
  },
  {
    "WhyChooseheading": "Diverse Fleet for All Corporate Travel Requirements",
    "WhyChoosedescription": "We offer a range of well-maintained vehicles including sedans, MUVs, and SUVs, equipped with modern safety features and comfort amenities. Whether your company requires daily employee pickups or executive transportation for site visits, our fleet supports it all with scalability and reliability."
  },
  {
    "WhyChooseheading": "Drivers Trained in Local Navigation and Industrial Protocols",
    "WhyChoosedescription": "Our drivers are experienced in navigating Sindhudurg’s roadways, including coastal routes and industrial corridors. Their knowledge of local conditions ensures timely arrivals, route optimization, and a safe experience even in remote locations or during monsoon conditions common to Konkan regions."
  },
  {
    "WhyChooseheading": "Flexible Scheduling for Shifts and Business Hours",
    "WhyChoosedescription": "We provide flexible booking models tailored for industrial clients—offering scheduled rides, recurring shift transport, and on-demand cab requests. This ensures businesses can align employee transportation with shift timings, production cycles, or visitor schedules."
  },
  {
    "WhyChooseheading": "Live GPS Tracking and Ride Monitoring",
    "WhyChoosedescription": "All eTravo vehicles are GPS-enabled, providing real-time ride tracking and monitoring. Admin teams can ensure trip accountability, employee safety, and make quick route adjustments if needed. This system is especially useful for monitoring travel in rural and coastal areas."
  },
  {
    "WhyChooseheading": "Transparent Invoicing and Monthly Reports",
    "WhyChoosedescription": "Our corporate billing system offers monthly invoices with detailed trip breakdowns, fare summaries, and digital logs. This helps companies track transportation usage, forecast budgets, and simplify expense documentation for HR and finance departments."
  },
  {
    "WhyChooseheading": "Hygiene and Safety Protocols You Can Trust",
    "WhyChoosedescription": "Vehicles are regularly sanitized and maintained, while drivers follow strict hygiene standards including mandatory health checks and mask usage. These precautions ensure that every commute is safe, especially for group transport and longer routes."
  },
  {
    "WhyChooseheading": "Corporate Support with Dedicated Account Managers",
    "WhyChoosedescription": "Each business client is assigned a dedicated account manager who offers end-to-end support—from setting up transport schedules to handling last-minute changes or inquiries, ensuring a smooth and responsive corporate experience in Sindhudurg MIDC."
  }
]
}

const faqData = [
  [
    {
      question: "Do your services cover all parts of Sindhudurg MIDC?",
      answer: "Yes, we cover all key areas within Sindhudurg MIDC and nearby industrial and agro-processing zones to ensure reliable connectivity."
    },
    {
      question: "Can we book recurring rides for our factory staff?",
      answer: "Absolutely. We offer recurring shift-based rides and fixed-route employee transportation services tailored for factory and plant operations."
    },
    {
      question: "Do you provide detailed monthly billing and reports?",
      answer: "Yes, we provide GST-compliant, itemized monthly invoices with complete trip logs and fare breakdowns for transparency and budget tracking."
    },
    {
      question: "Are drivers familiar with the local terrain and roads?",
      answer: "Yes, our drivers are trained and experienced in handling coastal, rural, and industrial routes common in Sindhudurg district."
    },
    {
      question: "What safety measures are followed during travel?",
      answer: "We ensure safety through GPS tracking, vehicle sanitization, driver health screening, and adherence to traffic and hygiene regulations."
    },
    {
      question: "Is there a dedicated point of contact for our business?",
      answer: "Yes, a dedicated account manager is assigned to each corporate client for streamlined communication and personalized service management."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Rajan Naik",
    designation: "Logistics Head, Konkan Exports Pvt Ltd",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab services in Sindhudurg MIDC have been timely, well-coordinated, and highly professional. They understand the region’s unique transport needs.”"
  },
  {
    name: "Ms. Savita Kambli",
    designation: "HR Executive, Western AgroTech Ltd",
    rating: [1, 1, 1, 1, 1],
    text: "“We rely on eTravo for our staff transportation across rural Sindhudurg MIDC locations. Their drivers and support team are incredibly dependable and proactive.”"
  }
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Sindhudurg MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-sindhudurg-midc.jpg",
  "description": "Trusted corporate cab service in Sindhudurg MIDC offering employee transport, business travel, and reliable industrial area cabs with AC comfort and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "4289"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-sindhudurg-midc"
  }
};





    return (
        <div>
<Helmet>
  <title>Cab Service in Sindhudurg MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Hire reliable corporate cab service in Sindhudurg MIDC for staff transport, business meetings, and industrial commutes. Book affordable AC corporate cabs at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default CAbserviceinsindhudurg;